import { MutableRefObject, createContext } from 'react';

import { CellItem } from '../RecyclerGridView/types';

type CellSelectionState = {
    selectedCellRef: MutableRefObject<CellItem | undefined>;
    selectedCell?: CellItem;
    setSelectedCell: (cell?: CellItem) => void;
};

const CellSelectionContext = createContext({} as CellSelectionState);

export default CellSelectionContext;
